import { useEnvironmentVariables } from "#app/EnvironmentProvider.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { isApiError } from "#lib/http/ApiError.ts";
import { useGetCurrentUserSuspenseQuery } from "#lib/useGetCurrentUserSuspenseQuery.ts";
import { Link, Text } from "@hopper-ui/components";
import { useCallback } from "react";
import { toast } from "react-toastify";

export const useCreateConversationErrorHandler = () => {
    const { tShared } = useSharedTranslation();
    const { data: { isAdmin } } = useGetCurrentUserSuspenseQuery();
    const { managementAppBaseUrl } = useEnvironmentVariables();

    return useCallback((error: unknown) => {
        if (isApiError(error) && error.status === 429) {
            if (isAdmin) {
                toast.error(
                    <Text>
                        {tShared("errors.quotaExceededAdmin")}
                        <Link href={`${managementAppBaseUrl}/settings/billing`} isExternal>{tShared("errors.quotaExceededAdminLink")}</Link>
                    </Text>

                );
            } else {
                toast.error(tShared("errors.quotaExceeded"));
            }
        } else {
            toast.error(tShared("errors.createConversation"));
        }
    }, [isAdmin, managementAppBaseUrl, tShared]);
};
